// Shared API/browser resolution policy. Registry parity is checked against
// BAC_MARKETS so a market-language change cannot silently split the readers.
export const MARKET_DEFAULT_LANG = Object.freeze({
  uk: "en", ie: "en", ca: "en", au: "en", nz: "en", za: "en",
  de: "de", fr: "fr", es: "es", it: "it", pt: "pt", dk: "da", se: "sv", mt: "en",
  br: "pt-BR", co: "es", ec: "es", mx: "es", be: "nl", pl: "pl", sk: "sk",
  no: "no", bg: "bg", fi: "fi", nl: "nl", at: "de", cz: "cs", ch: "de",
  ar: "es", lt: "en", lv: "en", in: "en-IN", global: "en",
});
const cleanPath = value => String(value || "").replace(/^\/+|\/+$/g, "");

export function landingPathCandidates(fullPath) {
  const clean = cleanPath(fullPath), segments = clean.split("/");
  const candidates = new Set([clean]);
  if (clean === "fi/pre-war-and-vintage-car-rental") {
    candidates.add("fi/sotia-edeltavan-vanhan-ajan-auton-vuokraus-haihin");
  }
  if (segments.length >= 2) {
    const [market, second, ...rest] = segments;
    const marketDefault = MARKET_DEFAULT_LANG[market];
    if (/^[a-z]{2}$/.test(second)) {
      const slug = rest.join("/");
      if (marketDefault && marketDefault !== second) candidates.add([market, marketDefault, slug].join("/"));
      if (second !== "en") candidates.add([market, "en", slug].join("/"));
      candidates.add([market, slug].filter(Boolean).join("/"));
      candidates.add(slug);
    } else {
      const slug = [second, ...rest].join("/");
      if (marketDefault) candidates.add([market, marketDefault, slug].join("/"));
      candidates.add([market, "en", slug].join("/"));
      candidates.add(slug);
    }
  }
  return [...candidates];
}

// Additional fallback admission requires the actual API response to bind this
// request to this active, same-market source. Candidate spelling alone is not
// authority; stock/country/brand/language checks still run in the caller.
export function landingFallbackMatchesSource(data, pathname) {
  const requested = cleanPath(pathname), stored = cleanPath(data?.page?.full_path);
  const market = requested.split("/")[0];
  return !!stored && data?.fallback === true && data.page?.active === true &&
    Object.hasOwn(MARKET_DEFAULT_LANG, market) && data.page.locale === market &&
    cleanPath(data.requestedPath) === requested && cleanPath(data.matchedPath) === stored &&
    landingPathCandidates(requested).includes(stored);
}
